import React from "react";
import { Link } from "react-router-dom";
import { Routes_path } from "../../routerApp";
import { PermissionTypes } from "../../authentication/permissionsGroups";
import Button from "@mui/material/Button";
import AutorizzazioneGruppi from "../../authentication/AutorizzazioneGruppi";
import { useTheme } from "@mui/material/styles";

interface HomeMenuButtonProps {
    nome: string;
    gruppiAutorizzati: PermissionTypes[];
    path: Routes_path;
    Icon: any;
}

const HomeMenuButton = ({
                            nome,
                            gruppiAutorizzati,
                            path,
                            Icon,
                        }: HomeMenuButtonProps) => {
    const theme = useTheme();

    return (
        <AutorizzazioneGruppi gruppiAutorizzati={gruppiAutorizzati}>
            <Button
                fullWidth
                variant="contained"
                component={Link}
                to={path}
                color="primary"
                sx={{
                    minHeight: 90,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    px: { md: 4, sm: 3, xs: 2 },
                    fontSize: { lg: "1vw", md: 20, sm: 14, xs: 14 },
                    fontWeight: theme.typography.button.fontWeight,
                    textTransform: theme.typography.button.textTransform,
                    letterSpacing: theme.typography.button.letterSpacing,
                    borderRadius: Number(theme.shape.borderRadius) * 2,
                    color: theme.palette.primary.contrastText,
                    background: theme.palette.primary.main,
                    boxShadow: theme.shadows[3],
                    transition: "all 0.3s ease-in-out",

                    "&:hover": {
                        background: theme.palette.secondary.main,
                        color: theme.palette.secondary.contrastText,
                        boxShadow: theme.shadows[6],
                        transform: "translateY(-2px)",
                    },
                }}
            >
                <Icon
                    sx={{
                        fontSize: { lg: "3vw", md: 50, sm: 25, xs: 22 },
                        mr: { md: 3, sm: 2, xs: 2 },
                        color: "inherit",
                    }}
                />
                {nome}
            </Button>
        </AutorizzazioneGruppi>
    );
};

export default HomeMenuButton;
